export default __webpack_public_path__ + "static/media/TEXTURA_07.488805f9.png";